import { render } from "./CollapsePage.vue?vue&type=template&id=ca982066&ts=true"
import script from "./CollapsePage.vue?vue&type=script&lang=ts"
export * from "./CollapsePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__